<template>
  <div class="lg:mr-44">
    <div
      :style="[
        { backgroundImage: 'url(/img/careers-expo-contact.jpg)' },
        { minHeight: '500px' },
        { backgroundPosition: '50% 20%' },
      ]"
      class="hero-gradient bg-cover relative w-full flex flex-col justify-end items-center pb-12 text-white mb-16"
    >
      <h4 class="z-20 font-poppins uppercase text-expo_red">Get in touch</h4>
      <h1 class="z-20 font-bold">Contact Us</h1>
    </div>

    <!-- Contact -->
    <div class="flex items-center justify-center pb-16">
      <div
        id="contact"
        class="flex items-center flex-wrap mb-4 max-w-7xl px-6 lg:px-0"
      >
        <div
          class="w-full flex flex-col lg:w-1/2 h-full bg-cover bg-center justify-center lg:pl-16"
        >
          <h4 class="text-lg mb-6 text-center lg:text-left">
            For general enquiries, you are welcome to give us a call, an email,
            or simply fill out the form and we'll get back you to you asap.
          </h4>
          <div class="flex flex-col space-y-1 mb-12">
            <div
              class="flex space-x-3 items-center text-expo_red group hover:text-expo_red"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="h-6 w-6"
                viewBox="0 0 20 20"
                fill="currentColor"
              >
                <path
                  d="M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.773a11.037 11.037 0 006.105 6.105l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z"
                />
              </svg>
              <h5 class="text-truegray-500">
                <a
                  class="font-normal text-base no-underline group-hover:text-expo_red"
                  href="tel:0274949316"
                  >027-494-9316</a
                >
              </h5>
            </div>
            <div
              class="flex space-x-3 items-center text-expo_red group hover:text-expo_red"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="h-6 w-6"
                viewBox="0 0 20 20"
                fill="currentColor"
              >
                <path
                  d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z"
                />
                <path
                  d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z"
                />
              </svg>
              <h5 class="text-truegray-500">
                <a
                  class="font-normal text-base no-underline group-hover:text-expo_red"
                  href="mailto:mark@careersexpo.org.nz"
                  >mark@careersexpo.org.nz</a
                >
              </h5>
            </div>
            <div
              class="flex space-x-3 items-center text-expo_red group hover:text-expo_red"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="h-6 w-6"
                viewBox="0 0 20 20"
                fill="currentColor"
              >
                <path
                  fill-rule="evenodd"
                  d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z"
                  clip-rule="evenodd"
                />
              </svg>
              <h5
                class="text-truegray-500 font-normal text-base no-underline group-hover:text-expo_red"
              >
                PO Box 612, Whangaparaoa, Auckland 0932
              </h5>
            </div>
          </div>
          <h5 class="text-truegray-500 text-sm text-center lg:text-left">
            Looking to register as an exhibitor or book your school into attend
            one of our events?
          </h5>
          <div class="flex space-x-4 my-4 justify-center lg:justify-start">
            <button
              class="btn btn-trans-black h-10"
              @click="handleRequest('school-registration')"
            >
              Schools
            </button>
            <button
              class="btn btn-trans-black h-10"
              @click="handleRequest('exhibitor-registration')"
            >
              Exhibitors
            </button>
          </div>
        </div>
        <div
          class="w-full lg:w-1/2 py-16 px-2 lg:p-16 flex flex-col justify-center space-y-4"
        >
          <div class="flex flex-col space-y-4 w-full">
            <!-- Organisation -->
            <div :class="inputWrapperClass" class="h-12">
              <h6 :class="inputLabelClass">Name</h6>
              <input
                id="name"
                v-model="name"
                type="text"
                name="name"
                autocomplete="name"
                :class="inputTextClass"
                @keyup="checkValidation"
                @change="checkValidation"
              />
            </div>
            <!-- /Organisation -->

            <!-- Email -->
            <div :class="inputWrapperClass" class="h-12">
              <h6 :class="inputLabelClass">Email</h6>
              <input
                id="email"
                v-model="email"
                type="email"
                name="email"
                autocomplete="email"
                :class="inputTextClass"
                @keyup="checkValidation"
                @change="checkValidation"
              />
            </div>
            <!-- /Email -->

            <!-- Comments -->
            <div :class="inputWrapperClass" class="h-24">
              <h6 :class="inputLabelClass">Questions or Comments</h6>
              <textarea
                id="comments"
                v-model="comments"
                type="textarea"
                name="comments"
                autocomplete="comments"
                rows="2"
                :class="inputTextAreaClass"
              />
            </div>
            <!-- /Comments -->
          </div>

          <button
            :disabled="!canSubmit"
            :class="[
              !canSubmit ? 'opacity-25 cursor-not-allowed' : '',
              thinking ? '' : '',
            ]"
            class="btn btn-expo-red relative w-40 mx-auto lg:mx-0"
            @click="contact"
          >
            <div class="flex justify-center items-center w-full h-full">
              <div
                class="absolute inset-0 w-full flex justify-center items-center z-20"
              >
                <lottie v-if="thinking" :options="loadingAnimationOptions" />
              </div>
              <div
                :class="[thinking ? 'invisible' : '']"
                class="w-full flex items-center justify-center"
              >
                Submit
              </div>
            </div>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { shared } from '../../../js/mixins/shared.js'
import { EventBus } from '../../../js/plugins/event-bus.js'
import * as loadingAnimation from '../../../shared/components/loading.json'

export default {
  mixins: [shared],

  data() {
    return {
      loadingAnimationOptions: { animationData: loadingAnimation.default },
      loadingAnimate: false,

      canSubmit: false,
      thinking: false,

      name: '',
      email: '',
      comments: '',

      currentYear: new Date().getFullYear(),

      inputWrapperClass:
        'rounded relative bg-white shadow border border-truegray-300 ',
      inputLabelClass:
        'absolute transform duration-100 ease-linear px-1 left-3 top-1 z-40 text-truegray-700',
      inputTextClass:
        'flex-grow px-4 mr-0 mt-1 outline-none focus:outline-none bg-transparent w-full h-12 font-primary text-black focus:placeholder-truegray-300',
      inputTextAreaClass:
        'flex-grow px-4 mr-0 mt-5 outline-none focus:outline-none bg-transparent h-18 font-primary text-black  focus:placeholder-truegray-300 transition-all duration-100 ease-in-out w-full',
      btnClass:
        'bg-black border-none flex justify-center items-center font-primary font-bold py-0',
    }
  },

  watch: {
    email: {
      handler: function (val) {
        // Remove all white space from inputs...
        val = val.replace(/\s+/g, '') // or you can use your own preferred way to remove leading spaces
        this.$set(this, 'email', val)
      },

      deep: true,
    },
  },

  methods: {
    handleRequest(item) {
      this.$router.push({ path: '/' + item })
    },

    contact() {
      // Disable the sign in button so that we do not interupt or clog up the call...
      this.$set(this, 'thinking', true)
      // Submit the access auth and kill the preloader...
      axios
        .post('/api/expo-contact', {
          email: this.email,
          name: this.name,
          comments: this.comments,
        })
        .then((response) => {
          this.$set(this, 'thinking', false)
          // this.$set(this,'canSubmit',true);

          let returned = response.data

          if (returned.success) {
            this.$set(this, 'emailSubmitResponseSuccess', true)
            EventBus.$emit('triggerAlertResponse', {
              status: 'success',
              message:
                'Your email has been sent. The team will be in touch soon!',
            })
          } else {
            EventBus.$emit('triggerAlertResponse', {
              status: 'error',
              message: 'Something went wrong!',
            })
          }
          this.name = ''
          this.email = ''
          this.comments = ''
        })
    },

    checkValidation() {
      let canSubmit = true
      // Enable / dissable sign in button depending on the validity of the email they have provided
      if (!this.resetPassword) {
        if (!this.validateEmail(this.email) || this.name.length < 3) {
          canSubmit = false
        }
      } else {
        if (!this.validateEmail(this.email)) {
          canSubmit = false
        }
      }

      this.$set(this, 'canSubmit', canSubmit)
    },

    noemptychars: function (event) {
      if (event.keyCode === 32) {
        event.preventDefault()
      }
    },
  },
}
</script>

<style scoped>
.hero-gradient::after {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 1;
  height: 100%;
  background: rgb(0, 0, 0);
  background: linear-gradient(
    0deg,
    rgba(0, 0, 0, 0.804359243697479) 0%,
    rgba(0, 0, 0, 0.5942752100840336) 36%,
    rgba(0, 0, 0, 0) 100%
  );
}
</style>
